import customersService from '../../services/customersService'
import activitiesService from '../../services/activitiesService'
import customerRelationshipsService from '../../services/customerRelationshipsService'

class CustomersController {
  searchCustomers = customersService.searchCustomers
  fetchCustomerDetails = customersService.fetchCustomerDetails
  updateCustomerDetails = customersService.updateCustomerDetails
  createCustomer = customersService.createCustomer
  followCustomer = customerRelationshipsService.followCustomer
  unfollowCustomer = customerRelationshipsService.unfollowCustomer
  validateCustomerToken = customersService.validateCustomerToken
  unsubscribe = customersService.unsubscribe
  anonymiseCustomer = customersService.anonymiseCustomer
  fetchCustomerStoreMarketingForId = customersService.fetchCustomerStoreMarketingForId
  setCustomerStoreMarketingForId = customersService.setCustomerStoreMarketingForId
}

export default new CustomersController()
 


// WEBPACK FOOTER //
// ../src/controllers/customersController/customersController.js